import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogComponent } from '../components/confirmation-dialog/confirmation-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class ConfirmationDialogService {
  
  constructor(private modalService: NgbModal) { }

  public confirm(
    title: string,
    message: string,
    type: string = 'primary',
    btnOkText: string = 'OK',
    btnCancelText: string = 'Cancel',
    dialogSize: 'sm'|'lg' = 'sm',
    btnOKColor?: string): Promise<boolean> {
    const modalRef = this.modalService.open(ConfirmationDialogComponent, { size: dialogSize });
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.message = message;
    modalRef.componentInstance.btnOkText = btnOkText;
    modalRef.componentInstance.btnOKColor = btnOKColor;
    modalRef.componentInstance.btnCancelText = btnCancelText;
    modalRef.componentInstance.type = type;
    return modalRef.result;
  }

}
